import { ApiError } from './api';

/** Mensagem amigável para exibir na tela, com o código da requisição quando houver. */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status >= 500 && error.requestId) {
      return `${error.message} (código: ${error.requestId.slice(0, 8)})`;
    }
    return error.message;
  }
  // Erros do próprio navegador: mostra o detalhe para facilitar o suporte.
  if (error instanceof Error && error.message) {
    return `Algo deu errado: ${error.message}`;
  }
  return 'Algo deu errado. Tente novamente.';
}
